import React, {useState, useMemo, useEffect} from 'react';
import {connect} from 'react-redux';
import Typography from '@material-ui/core/Typography';
import {
  Button,
  Grid,
  Paper,
  FormControl,
  Input,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import {Add, Search} from '@material-ui/icons';
import {find, findIndex, cloneDeep, filter, includes} from 'lodash';
import ParameterDialog from './ParameterDialog';
import ParameterTable from './ParameterTable';
// import { parameterList } from '../MockData';
import {dialogModes} from '../Constants';
import * as parameterServices from './parameterServices';

function Parameters({
  onOverlay,
  selectedParameters,
  toggleSelector,
  updateSelection,
  getParameterList,
  parameterList,
  areaId
}) {
  const [isModalOpen,
    toggleModal] = useState(false);
  const [parameterToEdit,
    setParameterToEdit] = useState(null);
  const [dialogMode,
    changeDialogMode] = useState(dialogModes.add);
  const selectedParameterList = useMemo(() => cloneDeep(selectedParameters), [selectedParameters]);

  useEffect(() => {
    if (!parameterList.length) 
      getParameterList();
    }
  , []);

  const prepareParameters = () => {
    if (onOverlay) {
      const parameterListData = filter(parameterList, (parameter) => {
        const pIndex = findIndex(selectedParameters, (selectedParameter) => selectedParameter.parameter.id === parameter.id);
        return pIndex === -1;
      });
      return parameterListData;
    } else {
      return parameterList;
    }
  };

  const [parameters,
    updateParameterList] = useState(prepareParameters());

  useEffect(() => {
    updateParameterList(prepareParameters());
  }, [parameterList]);

  useEffect(() => {
    updateParameterList(prepareParameters());
  }, [selectedParameters]);

  const handleSelection = (isSelected, parameter) => {
    const parameterListDataCopy = cloneDeep(parameters);
    const parameterDataIndex = findIndex(parameterListDataCopy, (item) => item.id === parameter.id);
    parameterListDataCopy[parameterDataIndex].isSelected = isSelected;
    updateParameterList(parameterListDataCopy);
    if (isSelected) {
      selectedParameterList.push(parameter);
    } else {
      const parameterIndex = findIndex(selectedParameterList, (item) => item.id === parameter.id);
      if (parameterIndex > -1) 
        selectedParameterList.splice(parameterIndex, 1);
      }
    };

  const editParameter = (parameterId) => {
    if (!parameterId) 
      return;
    const parameter = find(parameters, (item) => item.id === parameterId);
    if (!parameter) 
      return;
    changeDialogMode(dialogModes.update);
    setParameterToEdit({
      ...parameter
    });
    toggleModal(true);
  };

  const onSearch = (e) => {
    if (e.target.value) {
      const filteredList = filter(parameters, (p) => includes(p.name.toUpperCase(), e.target.value.toUpperCase()));
      updateParameterList(filteredList);
      return;
    }
    updateParameterList(prepareParameters());
  };

  return (
    <React.Fragment>
      <ParameterDialog
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        dialogMode={dialogMode}
        parameterToEdit={parameterToEdit}
        changeDialogMode={changeDialogMode}
        setParameterToEdit={setParameterToEdit}/>
      <Grid
        container
        direction="column"
        style={{
        flexGrow: 1,
        marginTop: '16px'
      }}
        spacing={4}>
        <Grid item>
          <Paper style={{
            padding: 8
          }}>
            <Grid
              container
              style={{
              flexGrow: 1
            }}
              direction="row"
              justify="space-between"
              alignItems="center">
              <Grid item>
                <Typography variant="h6">Parameters</Typography>
              </Grid>
              <Grid item>
                <FormControl>
                  <Input
                    id="input-with-icon-adornment"
                    startAdornment={< InputAdornment position = "start" > <Search color="primary"/> < /InputAdornment>}
                    onChange={onSearch}/>
                </FormControl>
              </Grid>

              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => toggleModal(!isModalOpen)}>
                  Add
                </Button>
                {onOverlay
                  ? (
                    <React.Fragment>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => toggleSelector(false)}
                        style={{
                        marginLeft: 8
                      }}>
                        Close
                      </Button>
                    </React.Fragment>
                  )
                  : null}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item>
          <ParameterTable
            areaId={areaId}
            parameterList={parameters}
            editParameter={editParameter}
            onOverlay={onOverlay
            ? true
            : false}
            handleSelection={handleSelection}/>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({parameterList: state.parameter.parameterList});

const mapDispatchToProps = (dispatch) => ({
  getParameterList: () => dispatch(parameterServices.getParameterList())
});

export default connect(mapStateToProps, mapDispatchToProps)(Parameters);



// WEBPACK FOOTER //
// ./src/parameter/Parameters.js